module.exports = __webpack_public_path__ + "img/mapa-regtech-mundo.a71634ba.png";